const SKEW_ANGLE_DEG = 12.1;
const TAN_SKEW = Math.tan(SKEW_ANGLE_DEG * Math.PI / 180);

function alignCategoryBoxRows(list) {
    if (!list.querySelector('.categoryBox')) return;

    const cols = [...list.querySelectorAll('.row > [class*="col-"]')]
        .filter(col => col.querySelector('.categoryBox'));

    if (cols.length < 2) return;

    const row = list.querySelector('.row');

    // Reset
    cols.forEach(col => col.style.transform = '');
    if (row) row.style.paddingLeft = '';

    // Single-column mobile: no offset needed
    if (window.innerWidth < 1024) return;

    // Group columns by row using their top position
    const rowMap = new Map();
    cols.forEach(col => {
        const top = Math.round(col.getBoundingClientRect().top);
        if (!rowMap.has(top)) rowMap.set(top, []);
        rowMap.get(top).push(col);
    });

    const sortedRows = [...rowMap.entries()].sort(([a], [b]) => a - b);
    if (sortedRows.length < 2) return;

    const firstRowTop = sortedRows[0][0];
    const lastRowTop  = sortedRows[sortedRows.length - 1][0];
    const maxOffset   = (lastRowTop - firstRowTop) * TAN_SKEW;

    // Pad the row container so the most-shifted row (first) still fits inside
    if (row) row.style.paddingLeft = `${maxOffset.toFixed(1)}px`;

    sortedRows.forEach(([rowTop, rowCols]) => {
        // Cumulative shift from first row – each row moves left relative to the padding
        const offset = (rowTop - firstRowTop) * TAN_SKEW;
        rowCols.forEach(col => {
            col.style.transform = `translateX(-${offset.toFixed(1)}px)`;
        });
    });
}

export function initCategoryBoxAlignment() {
    function run() {
        document.querySelectorAll('.categoryList').forEach(alignCategoryBoxRows);
    }

    run();

    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(run, 120);
    });
}
